export const LOAD_CUSTOMERCATEGORIES_SUCCESS = "LOAD_CUSTOMERCATEGORIES_SUCCESS";

export const CREATE_CUSTOMERCATEGORY_SUCCESS = "CREATE_CUSTOMERCATEGORY_SUCCESS";

export const SAVE_CUSTOMERCATEGORY_SUCCESS = "SAVE_CUSTOMERCATEGORY_SUCCESS";
export const DELETE_CUSTOMERCATEGORY_SUCCESS = "DELETE_CUSTOMERCATEGORY_SUCCESS";

export const LOAD_CUSTOMERCATEGORY_DETAIL_SUCCESS = "LOAD_CUSTOMERCATEGORY_DETAIL_SUCCESS";

export const CREATE_CUSTOMERCATEGORY = "CREATE_CUSTOMERCATEGORY";
export const SAVE_CUSTOMERCATEGORY = "SAVE_CUSTOMERCATEGORY";
